var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgS3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 57,
    viewBox: "0 0 60 57",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8713_1765)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0145 0.0571624H37.748L19.3387 54.634C19.2446 54.9127 19.1076 55.1751 18.9327 55.4116C18.7581 55.6484 18.5476 55.8559 18.3086 56.0275C18.0697 56.199 17.806 56.3324 17.5258 56.4223C17.2456 56.5122 16.9534 56.5586 16.6597 56.5586H2.85856C2.41056 56.5586 1.96855 56.4522 1.57 56.247C1.17102 56.0423 0.826608 55.7454 0.565362 55.3809C0.303945 55.0165 0.132927 54.5951 0.0664162 54.1515C-0.00025966 53.708 0.0401954 53.2548 0.183286 52.83L17.3347 1.98028C17.4284 1.70158 17.5655 1.43938 17.7408 1.20264C17.9153 0.965902 18.1266 0.758383 18.3648 0.586824C18.6038 0.415264 18.8675 0.281913 19.1477 0.192013C19.4279 0.102112 19.7201 0.0556641 20.0138 0.0556641V0.0564132L20.0145 0.0571624Z",
    fill: "url(#paint0_linear_8713_1765)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.705 56.5587H36.7814C36.6039 56.5587 36.4263 56.5422 36.251 56.5085C36.0765 56.4755 35.9049 56.4261 35.7393 56.3609C35.5738 56.2957 35.415 56.2148 35.2644 56.1204C35.114 56.0254 34.9728 55.9165 34.8426 55.7953L16.7727 38.9195C16.5815 38.7411 16.4484 38.5093 16.3906 38.2543C16.3328 37.9992 16.3531 37.7327 16.4489 37.4894C16.5447 37.2461 16.7116 37.0372 16.9277 36.89C17.1443 36.7432 17.3997 36.6646 17.6612 36.6646H45.7819L52.7035 56.5594L52.705 56.5587Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8116 0.057164L25.3979 36.6682L45.6808 36.6637L52.6384 56.5586H36.7747C36.6107 56.5571 36.4466 56.5421 36.2848 56.5129C36.123 56.4837 35.9641 56.441 35.8098 56.3841C35.5004 56.2713 35.2125 56.1063 34.9588 55.8964L22.7608 44.512L19.3461 54.5823C19.2577 54.834 19.1363 55.073 18.985 55.2925C18.6817 55.7341 18.2668 56.0875 17.7826 56.3166C17.5415 56.4307 17.2863 56.5121 17.0237 56.5586H2.86667C2.41418 56.5601 1.96767 56.4522 1.56537 56.244C1.163 56.0359 0.816655 55.734 0.555597 55.3638C0.29454 54.9936 0.12645 54.566 0.0655353 54.1171C0.00484136 53.668 0.0528868 53.2109 0.20563 52.7843L17.3293 2.01848C17.4185 1.73455 17.5526 1.4671 17.7264 1.22587C17.8995 0.984633 18.1107 0.77187 18.3505 0.596565C18.5902 0.421259 18.8569 0.284911 19.1393 0.193512C19.4218 0.102114 19.7177 0.0556657 20.0151 0.057164H37.8123H37.8116Z",
    fill: "url(#paint1_linear_8713_1765)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.8165 52.83C59.9597 53.255 60 53.7079 59.9342 54.1515C59.8676 54.5949 59.6968 55.0162 59.436 55.3809C59.1746 55.7451 58.8304 56.0419 58.4316 56.2467C58.0328 56.4515 57.591 56.5584 57.1428 56.5586H37.3782C37.8262 56.5586 38.2682 56.4515 38.6675 56.2469C39.0661 56.0424 39.4107 55.745 39.6722 55.3809C39.9336 55.0168 40.1044 54.595 40.1711 54.1515C40.2378 53.708 40.1973 53.2548 40.0543 52.83L22.9021 1.97874C22.7133 1.41858 22.3535 0.931745 21.8735 0.58679C21.6352 0.415231 21.3715 0.282628 21.0921 0.192728C20.8126 0.102828 20.5205 0.0571289 20.2275 0.0571289H39.9913C40.285 0.0571289 40.5764 0.102828 40.8566 0.192728C41.136 0.282628 41.3998 0.41598 41.6387 0.58679C41.877 0.75835 42.0875 0.965869 42.262 1.20186C42.4366 1.43784 42.573 1.70005 42.6674 1.97874L59.8195 52.83H59.8165Z",
    fill: "url(#paint2_linear_8713_1765)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8713_1765",
    x1: 26.4866,
    y1: 4.24501,
    x2: 8.05704,
    y2: 58.687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#114A8B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0669BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8713_1765",
    x1: 32.2325,
    y1: 29.6118,
    x2: 27.9698,
    y2: 31.0577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8713_1765",
    x1: 29.8806,
    y1: 2.65674,
    x2: 50.1081,
    y2: 56.5444,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3CCBF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2892DF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8713_1765"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 56.616,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgS3);
export default __webpack_public_path__ + "static/media/s3.63684e9f4b07a34b56e27488f3b8eeb8.svg";
export { ForwardRef as ReactComponent };